import { createAction } from '@reduxjs/toolkit';
export const UNMUTE_CONFERENCE_PARTICIPANT = 'UNMUTE_CONFERENCE_PARTICIPANT';
export const unmuteConferenceParticipantAction = createAction(UNMUTE_CONFERENCE_PARTICIPANT);